// import { isMobileBrowser } from './isMobileBrowser';
// import { setCookie } from './cookie';

export function getChannelInfoId(): string {
  return '1';
  // const searchParams = new URLSearchParams(window.location.search);
  // const idFromQueryParam = searchParams.get('channelIdInfo');
  // if (idFromQueryParam) {
  //   setCookie({
  //     name: 'channelId_Ar',
  //     value: idFromQueryParam,
  //     domain: '.coteetsport.ma',
  //   });
  //   return idFromQueryParam;
  // }
  // const mobileBrowser = isMobileBrowser();
  // const isPWA =
  //   window.matchMedia('(display-mode: standalone)').matches ||
  //   (window.navigator as Navigator & { standalone?: boolean }).standalone ===
  //     true;
  // const channel = isPWA ? '4' : mobileBrowser ? '3' : '1';
  // setCookie({
  //   name: 'channelId_Ar',
  //   value: channel,
  //   domain: '.coteetsport.ma',
  // });
  // return channel;
}
